import { Company, CreateCompanyForm } from '@/types/company';
import { Query } from '@/types/query';
import { PaginatedResponse, Response } from '@/types/response';
import { api } from '@/utils/axios';

export const CreateCompany = async (
  data: CreateCompanyForm,
): Promise<Response<Company>> => {
  const res = await api.post(`/app-web/companies`, data);
  return res.data;
};

export const ListCompanies = async (
  query: Query,
): Promise<PaginatedResponse<Company> | Response<Company[]>> => {
  const res = await api.get(`/app-web/companies`, {
    params: query,
  });
  return res.data;
};

export const ShowCompany = async (id: number): Promise<Response<Company>> => {
  const res = await api.get(`/app-web/companies/${id}`);
  return res.data;
};

export const UpdateCompany = async (
  data: Company,
): Promise<Response<Company>> => {
  const res = await api.put(`/app-web/companies/` + data.id, data);
  return res.data;
};

export const DeleteCompany = async (id: number): Promise<Response> => {
  const res = await api.delete(`/app-web/companies/` + id);
  return res.data;
};

export const UpdateCompanyLogo = async (
  company_id: number,
  logo: string,
): Promise<Response<Company>> => {
  const res = await api.put(`/app-web/companies/${company_id}/logo`, {
    logo,
  });

  return res.data;
};

export const DeleteLogoCompany = async (
  company_id: number,
): Promise<Response<Company>> => {
  const res = await api.delete(`/app-web/companies/` + company_id + `/logo`);
  return res.data;
};
